import { render, staticRenderFns } from "./Rates.vue?vue&type=template&id=747dd4fa&scoped=true&"
import script from "./Rates.vue?vue&type=script&lang=js&"
export * from "./Rates.vue?vue&type=script&lang=js&"
import style0 from "./Rates.vue?vue&type=style&index=0&id=747dd4fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747dd4fa",
  null
  
)

export default component.exports